import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-network-details',
  templateUrl: './network-details.component.html',
  styleUrls: ['./network-details.component.scss'],
})
export class NetworkDetailsComponent implements OnInit {
  isSubmitted = false;
  personalInfoForm: any;
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();
  selectedShippingAddress: any;
  cart: any;
  networkDetailForm: any;
  group: any;
  subRegion: any;
  constructor(
    private SS: SubjectService,
    private FB: FormBuilder,
    private modalController: ModalController,
    private route: Router,
    private GAS: GoogleAnalyticsService,
    private AAS: AdobeAnalyticsService,
    private UTS: UtilitiesService
  ) {
    this.networkDetailForm = this.FB.group({
      group: [''],
      exchange: [''],
      oltCode: [''],
      subRegion: [''],
    });
  }

  ngOnInit() {
    const networkDetails = JSON.parse(localStorage.getItem('ND'));
    if (networkDetails && Object.keys(networkDetails).length > 0) {
      if (networkDetails.group) {
        this.networkDetailForm.controls['group'].setValue(networkDetails.group);
        this.group = networkDetails.group;
      }
      if (networkDetails.exchange) {
        this.networkDetailForm.controls['exchange'].setValue(networkDetails.exchange);
      }
      if (networkDetails.oltCode) {
        this.networkDetailForm.controls['oltCode'].setValue(networkDetails.oltCode);
      }
      if (networkDetails.subRegion) {
        this.networkDetailForm.controls['subRegion'].setValue(networkDetails.subRegion);
        this.subRegion = networkDetails.subRegion;
      }
    }
  }
  get errorControl() {
    return this.networkDetailForm.controls;
  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  personalInfoSubmitted() {
    if (this.networkDetailForm.valid) {
      this.route.navigate(['/create-request/requestDetail']);
    }
  }
  goHome() {
    this.route.navigateByUrl('/home');
  }
  enbleContinue() {
    return this.networkDetailForm.valid;
  }

  getGroups() {
    return [
      { name: 'FTTX', id: 'FTTX' },
      { name: 'MEGA', id: 'MEGA' },
    ];
  }
  selectGroup(e) {
  }

  getSubRegion() {
    //, WR, DXB, WC, EC, RAK

    return [
      { name: 'Abu Dhabi', id: 'AUH' },
      { name: 'Al Ain', id: 'AAN' },
      { name: 'Abu Dhabi Western Region', id: 'WR' },
      { name: 'Dubai', id: 'DXB' },
      { name: 'Ajman', id: 'WC' },
      { name: 'Fujairah', id: 'EC' },
      { name: 'Ras Al Khaima', id: 'RAK' },
    ];
  }
  selectSubRegion(e) {
    
  }

  submitNetworkDetails() {
    
    localStorage.setItem('ND', JSON.stringify(this.networkDetailForm.value))
    setTimeout(() => {
    this.SS.networkDetail.next(this.networkDetailForm.value);
    this.dismiss();
  }, 500);
  }
}
